// 域名配置系统 - 根据不同域名显示不同信息

// 定义不同域名下的配置信息
const DOMAIN_CONFIGS = {
  // 默认配置
  'default': {
    companyName: '杭州那又谁科技有限公司',
    copyrightText: '© 2025, 杭州那又谁科技有限公司 版权所有',
    icpNumber: '浙ICP备2022036757号-1',
    siteName: '沸推AI',
    siteDescription: '新时代的好员工'
  },
  
  // 可以为不同域名定义不同的配置
  'www.shashadonghua1314.com': {
      companyName: '杭州造图科技有限公司',
      copyrightText: '© 2025, 杭州造图科技有限公司 版权所有',
      icpNumber: '浙ICP备2022035757号-1',
      siteName: '沸推AI',
      siteDescription: '新时代的好员工'
  },
  'feituiai.com': {
      companyName: '杭州造图科技有限公司',
      copyrightText: '© 2025, 杭州造图科技有限公司 版权所有',
      icpNumber: '浙ICP备2022035757号-8',
      siteName: '沸推AI',
      siteDescription: '新时代的好员工'
  },
  'www.feituiai.com': {
      companyName: '杭州造图科技有限公司',
      copyrightText: '© 2025, 杭州造图科技有限公司 版权所有',
      icpNumber: '浙ICP备2022035757号-8',
      siteName: '沸推AI',
      siteDescription: '新时代的好员工'
  },
  'localhost': {
      companyName: '杭州造图科技有限公司',
      copyrightText: '© 2025, 杭州造图科技有限公司 版权所有',
      icpNumber: '浙ICP备2022035757号-1',
      siteName: '沸推AI',
      siteDescription: '新时代的好员工'
  },
  
  // 可以继续添加更多域名配置
};

/**
 * 获取当前域名的配置信息
 * @returns {Object} 域名配置对象
 */
export const getCurrentDomainConfig = () => {
  const hostname = window.location.hostname;
  
  // 如果访问的是 motubizhi.com 域名，则重定向到 www.feituiai.com
  if (hostname === 'motubizhi.com'||hostname === 'www.motubizhi.com') {
    window.location.replace('https://www.feituiai.com' + window.location.pathname + window.location.search);
    return DOMAIN_CONFIGS['www.feituiai.com'];
  }
  
  return DOMAIN_CONFIGS[hostname] || DOMAIN_CONFIGS['default'];
};

/**
 * 根据键名获取当前域名的特定配置值
 * @param {string} key - 配置键名
 * @returns {*} 配置值
 */
export const getDomainConfigValue = (key) => {
  const config = getCurrentDomainConfig();
  return config[key];
};

export default {
  getCurrentDomainConfig,
  getDomainConfigValue
};